(function(angular) {
    'use strict';
    
    angular.module('shared')
    .controller('FooterCtrl', ['$scope',function ($scope) {
        
    }]);

})(window.angular);